import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SplitScreenLayout } from "../../design-system";
import { useWsPath } from "../../workspaces";
import { SnippetContextProvider } from "../docs/snippetContext";
import { AddAgentWizard } from "../../components/layout/AddAgentWizard";
import { WelcomeTimeline } from "./WelcomeTimeline";

/* The workspace-scoped first-run wizard as the page itself, not a dialog: first run has no
 * dashboard behind it to dim or dismiss back to. A mid-flow refresh starts over. */
export default function WelcomePage() {
  const ws = useWsPath();
  const navigate = useNavigate();

  // Remounting the provider is what starts "connect another" on a fresh agent and key.
  const [runId, setRunId] = useState(0);

  return (
    <SplitScreenLayout
      leftPanel={<WelcomeTimeline />}
      /* max-w-lg (512px), top-anchored so the frame stays put between steps.
         Was an arbitrary max-w-[384px]: too narrow for the connect step's code
         blocks and URL rows, which wrapped mid-token while the right pane sat
         mostly empty. 512 is a scale value, keeping the column off arbitrary
         sizes, and AddAgentModal holds the same width so the wizard reads
         identically as a page and as a dialog. */
      contentClassName="mb-auto mt-[12vh] max-w-lg"
    >
      <div className="onboarding onboarding-card">
        <SnippetContextProvider key={runId}>
          <AddAgentWizard
            onFinish={(agentId) =>
              navigate(ws(`/agents/${encodeURIComponent(agentId)}`), {
                replace: true,
              })
            }
            onAddAnother={() => setRunId((n) => n + 1)}
          />
        </SnippetContextProvider>
      </div>
    </SplitScreenLayout>
  );
}
